import FAQ from './FAQ';
export default FAQ;
